import { selectIsSegmentAnalysisEmailOpenRateFeatureFlagOn } from 'core/userContext';
import { MetricDefinitionPopOver } from 'modules/productAnalytics';
import { SEGMENT_METRIC_DEF_EXCEPTIONS } from 'modules/productAnalytics/constants';
import { useMetricsContext } from 'modules/productAnalytics/context';
import { useSelector } from 'react-redux';

type MetricDefinitionWrapperProps = {
  metricName: string;
  children: React.ReactNode;
  inSegmentAnalysis?: boolean;
};

export const MetricDefinitionWrapper = ({
  children,
  metricName,
  inSegmentAnalysis = false,
}: MetricDefinitionWrapperProps) => {
  const isSegAnalysisEmailOpenRateFFOn = useSelector(
    selectIsSegmentAnalysisEmailOpenRateFeatureFlagOn,
  );
  const { analyticsMetricDefinitions, highLevelMetricDefinitions } = useMetricsContext();

  const segmentExceptionDefinition =
    inSegmentAnalysis && isSegAnalysisEmailOpenRateFFOn && metricName === 'Email Open Rate'
      ? SEGMENT_METRIC_DEF_EXCEPTIONS[metricName]
      : undefined;

  const metricDefinition =
    segmentExceptionDefinition ||
    highLevelMetricDefinitions?.[metricName?.toLowerCase()] ||
    analyticsMetricDefinitions?.[metricName?.toLowerCase()];

  return (
    <MetricDefinitionPopOver
      definition={metricDefinition?.definition}
      learnMoreLink={metricDefinition?.learnMoreLink}
    >
      <span>{children}</span>
    </MetricDefinitionPopOver>
  );
};
